<template>
  <div class="intro__features-slider">
    <div class="intro__features-slider-title-wrapper">
      <div class="intro__features-slider-title-container">
        <div ref="title" class="intro__features-slider-title">
          <div v-for="item in slider" :key="item.name"
               class="intro__features-slider-title-item"
               :class="[item.name, { active: item.active }]"
               :data-main="item.titles.main"
               :data-mobile="item.titles.mobile"
               @click="onChooseItem(item.name)">
            <inline-svg :src="`/images/v4/svg/${item.name}.svg`" />
          </div>
        </div>
      </div>
    </div>
    <div class="intro__features-slider-images">
      <div class="intro__features-slider-images-wrapper">
        <div v-for="item in slider" :key="item.name"
             class="intro__features-slider-image"
             :class="{ active: item.active }">
          <picture>
            <img :src="item.image" :alt="item.name">
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroSlider',
  data() {
    return {
      slider: [{
        name: 'table',
        titles: {
          main: 'Таблицы',
          mobile: 'Таблицы',
        },
        active: true,
        image: '/images/v4/images/intro/image-main-sheets@2x.webp',
      }, {
        name: 'document',
        titles: {
          main: 'Документы',
          mobile: 'Документы'
        },
        active: false,
        image: '/images/v4/images/intro/image-main-doc@2x.webp',
      }, {
        name: 'task',
        titles: {
          main: 'Задачи',
          mobile: 'Задачи'
        },
        active: false,
        image: '/images/v4/images/intro/image-main-task@2x.webp',
      }, {
        name: 'board',
        titles: {
          main: 'Доски',
          mobile: 'Доски'
        },
        active: false,
        image: '/images/v4/images/intro/image-main-board@2x.webp',
      }],
      sliderAnimation: 0,
      currentSlide: 0,
      restartAnimationTimeout: 0,
    };
  },
  methods: {
    runSliderAnimation() {
      this.sliderAnimation = setInterval(() => {
        const current = this.slider.findIndex((item) => {
          return item.active;
        });
        this.currentSlide = current + 1 < this.slider.length ? current + 1 : 0;

        this.slider[current].active = false;
        this.slider[this.currentSlide].active = true;
      }, 5000);
    },
    stopSliderAnimation() {
      clearInterval(this.sliderAnimation);
    },
    onChooseItem(name) {
      const next = this.slider.findIndex((item) => {
        return item.name === name;
      });
      const current = this.slider.findIndex((item) => {
        return item.active;
      });

      this.currentSlide = next ?? 0;

      this.slider[current].active = false;
      this.slider[this.currentSlide].active = true;

      clearTimeout(this.restartAnimationTimeout);
      this.stopSliderAnimation();

      this.restartAnimationTimeout = setTimeout(() => {
        this.runSliderAnimation();
      }, 20000);
    },
  },
  mounted() {
    this.runSliderAnimation();
  },
  beforeMount() {
    this.stopSliderAnimation();
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";
@import "@/styles/button-primary.scss";

.intro__features-slider {
  display: flex;
  flex-direction: column;
  align-items: center;

  .intro__features-slider-title-wrapper {
    padding: 0 20px;
  }

  .intro__features-slider-title-container {
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    border: 1px solid #D8DADD;
    border-radius: 30px;
    background: linear-gradient(189deg, rgba(0, 0, 0, 0.05) 8.57%, rgba(255, 255, 255, 0.05) 94.31%), #FFF;
    z-index: 2;
  }

  .intro__features-slider-title {
    overflow-x: scroll;
    justify-content: flex-start;
    -ms-overflow-style: none;
    scrollbar-width: none;
    display: flex;
    align-items: center;
    padding: 3px;

    .intro__features-slider-title-item {
      width: 160px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 700;
      line-height: normal;
      padding: 5px 0;
      color: #757981;
      border: 1px solid transparent;
      transition: all 0.5s ease-in-out;
      cursor: pointer;

      &:after {
        content: attr(data-main);
      }

      &.active {
        color: #333334;
        cursor: default;
        pointer-events: none;
        background-color: #ffffff;
        border: 1px solid #E9E9E9;
        border-radius: 1000px;
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.10);

        &.table {
          svg {
            fill: #5BA460;
          }
        }

        &.document {
          svg {
            fill: #597AF4;
          }
        }

        &.task {
          svg {
            fill: #333334;
          }
        }

        &.board {
          svg {
            fill: #f9834b;
          }
        }
      }

      svg {
        flex: 0 0 auto;
        width: 20px;
        height: 20px;
        fill: #757981;
        transition: fill 0.5s ease-in-out;
      }
    }
  }

  .intro__features-slider-images {
    width: 100%;
    max-width: 1000px;
    position: relative;
    overflow: hidden;
    z-index: 1;

    .intro__features-slider-images-wrapper {
      position: relative;
      width: 100%;
      padding-bottom: 65.4%;
    }

    .intro__features-slider-image {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;

      &.active {
        opacity: 1;
        visibility: visible;
      }

      img {
        width: 100%;
      }
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  .intro__features-slider {
    .intro__features-slider-images {
      padding: 0 30px;
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .intro__features-slider {
    .intro__features-slider-title {
      .intro__features-slider-title-item {
        min-width: 104px;
        max-width: 104px;
        font-size: 10px;
        gap: 4px;
        padding: 3px 0;

        &:after {
          content: attr(data-mobile);
        }

        svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    .intro__features-slider-images {
      padding: 0 20px;
    }
  }
}

@media (max-width: 464px) {
  .intro__features-slider {
    .intro__features-slider-title-wrapper {
      width: 100%;
    }
  }
}
</style>
